(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("UtilitiesCore", [], factory);
	else if(typeof exports === 'object')
		exports["UtilitiesCore"] = factory();
	else
		root["UtilitiesCore"] = factory();
})(self, function() {
return 